import React from "react";
import PropTypes from "prop-types";
//
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
//
import Dots from "../dots/Dots";
const useStyles = makeStyles({
  textContainer: {
    minHeight: 70
  },
  imageContainer: {
    textAlign: "center",
    height: 100,
    display: "grid",
    justifyContent: "center"
  },
  image: {
    maxHeight: 90,
    alignSelf: "center"
  }
});
const HelpPage = ({
  page,
  dots,
  pageButtons
}) => {
  const classes = useStyles({
    page
  });
  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.imageContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: page.image,
    alt: "Page Context",
    className: classes.image
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Dots, {
    items: dots
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.textContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary"
  }, page.text)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, pageButtons));
};
HelpPage.propTypes = {
  page: PropTypes.object,
  dots: PropTypes.array,
  pageButtons: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};
export default HelpPage;